export default __webpack_public_path__ + "static/media/pptSlide1.f994a829.jpg";